import {IModuleConfig} from '../../../utilites/module';
import { STREAM_ROUTER_ROOT, STREAM_ROUTER_NEW, STREAM_ROUTER_EDIT, STREAM_ROUTER_LIVE, STREAM_ROUTER_VIEW } from './constants';

import StreamList from './StreamList';
import StreamNew from './StreamNew';
import StreamEdit from './StreamEdit';
import StreamView from './StreamView';
import StreamRoot from './StreamRoot';
// import StreamUpcomming from '../CustomStream/StreamUpcomming';
// import StreamPast from '../CustomStream/StreamPast';
import StreamVoDRoot from '../CustomStream/StreamVoDRoot';
import { VOD_ROUTER_EDIT, VOD_ROUTER_NEW, STREAM_ROUTER_VOD } from '../CustomStream/constants';
import VideoOnDemandNew from '../CustomStream/Video/VideoOnDemandNew';
import VideoOnDemandEdit from '../CustomStream/VideoOnDemandEdit';

export const LiveStream: IModuleConfig = {
  router: [
    {
      path: STREAM_ROUTER_ROOT,
      component: StreamRoot,
      indexRoute: {
        onEnter: (nextState, replace) =>
          replace({pathname: STREAM_ROUTER_LIVE}),
      },
      childRoutes: [
        {
          path: STREAM_ROUTER_LIVE,
          component: StreamList
        },
        // {
        //   path: "upcoming",
        //   component: StreamUpcomming,
        // },
        // {
        //   path: "past",
        //   component: StreamPast,
        // },
        {
          path: STREAM_ROUTER_VOD,
          component: StreamVoDRoot,
        },
        {
          path: "vod/category/:category_id",
          component: StreamVoDRoot,
        }
      ],
    },
    {
      path: STREAM_ROUTER_NEW,
      component: StreamNew
    },
    {
      path: STREAM_ROUTER_EDIT,
      component: StreamEdit
    },
    {
      path: STREAM_ROUTER_VIEW,
      component: StreamView
    },
    {
      path: VOD_ROUTER_NEW,
      component: VideoOnDemandNew,
    },
    {
      path: VOD_ROUTER_EDIT,
      component: VideoOnDemandEdit,
    },
  ]
};

export default LiveStream;



// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/index.ts